var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayerGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.052,
    height: 23.046,
    viewBox: "0 0 23.052 23.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163210",
    "data-name": "Grupo 163210",
    transform: "translate(-1842.42 8905)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27428",
    "data-name": "Caminho 27428",
    d: "M119.608,32.354l-7.582-3.771a5.6,5.6,0,0,0-4.99,0l-7.582,3.771a2.608,2.608,0,0,0,0,4.67l7.582,3.771a5.6,5.6,0,0,0,4.99,0l7.582-3.771a2.608,2.608,0,0,0,0-4.67Z",
    transform: "translate(1744.415 -8932.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27429",
    "data-name": "Caminho 27429",
    d: "M120.927,231.234a3.536,3.536,0,0,1-.917.648l-7.58,3.772a6.623,6.623,0,0,1-5.9,0l-7.583-3.772a3.543,3.543,0,0,1-.917-.651,2.6,2.6,0,0,0,1.373,2.955l7.583,3.772a5.6,5.6,0,0,0,4.989,0l7.583-3.772a2.593,2.593,0,0,0,1.373-2.953Z",
    transform: "translate(1744.469 -9126.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27430",
    "data-name": "Caminho 27430",
    d: "M99.416,304.693l7.583,3.77a5.587,5.587,0,0,0,4.989,0l7.583-3.77a2.6,2.6,0,0,0,1.373-2.953,3.528,3.528,0,0,1-.917.648l-7.58,3.772a6.623,6.623,0,0,1-5.9,0l-7.583-3.772a3.527,3.527,0,0,1-.917-.648,2.6,2.6,0,0,0,1.373,2.953Z",
    transform: "translate(1744.452 -9194.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27431",
    "data-name": "Caminho 27431",
    d: "M99.413,375.083,107,378.855a5.6,5.6,0,0,0,4.989,0l7.583-3.772a2.6,2.6,0,0,0,1.373-2.953,3.6,3.6,0,0,1-.917.65l-7.58,3.77a6.623,6.623,0,0,1-5.9,0l-7.583-3.77a3.6,3.6,0,0,1-.917-.65,2.6,2.6,0,0,0,1.373,2.953Z",
    transform: "translate(1744.456 -9261.394)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayerGroup);
export default __webpack_public_path__ + "static/media/layer-group.c330c874a50d0cddd4823709e4179b51.svg";
export { ForwardRef as ReactComponent };